export interface TrackingUrl {
  carrierNameExact: string;
  deliveryMethodPartial?: string;
  trackingAddress: string;
}

export const TRACKING_URLS: TrackingUrl[] = [
  {
    carrierNameExact: "fedex",
    trackingAddress: "https://www.fedex.com/fedextrack/?tracknumbers=",
  },
  {
    carrierNameExact: "other",
    deliveryMethodPartial: "dhl",
    trackingAddress: "https://www.dhl.com/us-en/home/tracking.html?submit=1&tracking-id=",
  },
  {
    carrierNameExact: "ups",
    trackingAddress: "https://www.ups.com/track?loc=null&requester=ST&tracknum=",
  },
];

export const getTrackingUrl = (
  carrierName: string,
  deliveryMethod: string,
  trackingNumber: string
): string | null => {
  const carrier = carrierName.toLowerCase();
  const delivery = deliveryMethod.toLowerCase();

  const match = TRACKING_URLS.find((url) => {
    if (url.carrierNameExact === carrier) {
      if (url.deliveryMethodPartial) {
        return delivery.includes(url.deliveryMethodPartial);
      }
      return true;
    }
    return false;
  });

  return match ? `${match.trackingAddress}${trackingNumber}` : null;
};
